const KEY = "labtrack.filters.v1";

const today = () => new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD, local day

export const todayDefaults = () => ({ date_from: today(), date_to: today() });

const read = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); }
  catch (e) { console.warn("could not read saved filters:", e); return {}; }
};

/** Filters live for the whole login session and survive navigation between sections. */
export const loadFilters = (section, blank) => {
  const saved = read()[section];
  return saved ? { ...blank, ...saved } : { ...blank, ...todayDefaults() };
};

export const saveFilters = (section, filters) => {
  try {
    const all = read();
    all[section] = filters;
    sessionStorage.setItem(KEY, JSON.stringify(all));
  } catch (e) { console.warn("could not save filters:", e); }
};

export const clearAllFilters = () => sessionStorage.removeItem(KEY);

export const isToday = (f) => f?.date_from === today() && f?.date_to === today();
